module.exports = __webpack_public_path__ + "static/media/coolplanet.aacdf114.png";